export default function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        {/* AI Icon with Glow */}
        <div className="absolute inset-0 bg-[#0066FF]/30 blur-lg rounded-full"></div>
        <div className="relative w-10 h-10 bg-gradient-to-br from-[#0066FF] to-[#0052CC] rounded-xl flex items-center justify-center">
          <i className="ri-robot-2-line text-white text-xl"></i>
        </div>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-white font-bold text-lg">AI Lead</span>
        <span className="text-[#0066FF] font-bold text-lg -mt-1">System</span>
      </div>
    </div>
  );
}
